import type { ToccoSeminarFieldsFragment, ToccoModuleFieldsFragment } from '~/api/graphql/generated'

export interface SeminarCartProps {
  seminar: ToccoSeminarFieldsFragment | null
  modules: ToccoModuleFieldsFragment[]
}

export const useSeminarCartStore = defineStore('SeminarCart', {
  state: () => ({ seminar: null, modules: [] }) as SeminarCartProps,
  getters: {},
  actions: {
    setModules(modules: ToccoModuleFieldsFragment[]) {
      this.modules = modules
    },

    addModule(module: ToccoModuleFieldsFragment) {
      this.modules.push(module)
    },

    removeModule(module: ToccoModuleFieldsFragment) {
      const key = this.modules.findIndex((currentModule: ToccoModuleFieldsFragment) => currentModule.id === module.id)
      if (key !== -1) {
        this.modules.splice(key, 1)
      }
    },

    clearModules() {
      this.modules = []
    },

    setSeminar(seminar: ToccoSeminarFieldsFragment) {
      this.seminar = seminar
    },

    clearSeminar() {
      this.seminar = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSeminarCartStore, import.meta.hot))
}
